<div class="d-flex" *ngIf="params.colDef?.colId == 'StorageDays'">
  <span class="pe-4">
    {{ params.data?.name }}
  </span>
  <div class="position-relative">
    <img
      *ngIf="params.data.name.toLowerCase() == 'pallet unit'"
      tooltipClass="sku-tooltip"
      placement="auto"
      ngbTooltip="Account for Pallet configuration in actions"
      src="./assets/icons/grey-question-icon.svg"
      width="16"
      height="16"
    />
  </div>
</div>

<div class="d-flex" *ngIf="params.colDef?.colId == 'Status'">
  <span
    class="pe-4"
    [text]="
      params.rowIndex == 1
        ? 'The dashboard keeps a log of your existing projects. 
        Note: Packaging and Product projects are modelled independently.'
        : ''
    "
    [joyrideStep]="params.rowIndex == 1 ? 'step2' : 'step-twoex'"
    [stepPosition]="params.rowIndex == 1 ? 'right' : ''"
  >
    {{ params.data?.status }}
  </span>
</div>

<div class="d-flex" *ngIf="params.colDef?.colId == 'Uuid'">
  <span
    class="pe-4"
    id="uuid"
    [text]="
      params.rowIndex == 0
        ? 'UUID refers to each unique product or packaging stock keeping unit used within the organization. Other organizations may use the term SKU.'
        : ''
    "
    [joyrideStep]="params.rowIndex == 0 ? 'org-step-4' : 'org-step-xx'"
    [stepPosition]="params.rowIndex == 0 ? 'right' : ''"
  >
    {{ params.data?.uuid }}
  </span>
</div>
